import {getLogger} from "@prosay/logging"
import {defaultDataIdFromObject} from "apollo-cache-inmemory"
import {
    ConversationInfoFragment,
    ConversationInfoFragmentDoc,
    useConversationSubscription,
} from "../graphql"

const logger = getLogger(__filename)

export const useConversationUpdateSubscription = (id: string) =>
    useConversationSubscription({
        onSubscriptionData: logger.debug(
            ({client, subscriptionData: {data}}) => {
                if (!data?.conversation) {
                    logger.info`Received a subscription update for the "conversation" subscription, but the "conversation" field was null!`
                    return
                }

                const cacheId = defaultDataIdFromObject(data.conversation.id)
                if (!cacheId) {
                    logger.info`Could not get the cache id for ${data.conversation}`
                    return
                }
                client.writeFragment<ConversationInfoFragment>({
                    data: data.conversation,
                    fragment: ConversationInfoFragmentDoc,
                    id: cacheId,
                })
            },
            "useConversationUpdateSubscription::onSubscriptionData",
        ),
        variables: {id},
    })
